export default "__VITE_ASSET__DfIjyvFh__"